import { Navigate } from '@sorare/routing';
import { ANY_SPORT_MARKET_SCOUT } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const RedirectToScoutingCenter = () => {
  const { generateSportContextPath } = useSportContext();
  return <Navigate to={generateSportContextPath(ANY_SPORT_MARKET_SCOUT)} />;
};

export default RedirectToScoutingCenter;
